import React from "react";
import AutoStoriesIcon from '@mui/icons-material/AutoStories';

function Header() {
  return (
    <header>
      <h1><AutoStoriesIcon sx={{fontSize:25}}/> Keeper</h1>
    </header>
  );
}

export default Header;
